export class FormHelpers {
    validateForm(form) {
        let isValid = true;
        document.querySelectorAll('.error').forEach((error) => {
            error.classList.remove('error');
        });
        const requiredFields = form.querySelectorAll('[data-required]');
        requiredFields.forEach((field) => {
            if (field.value === '') {
                field.parentElement.classList.add('error');
                isValid = false;
            }
            if (field.getAttribute('type') === 'email') {
                const email = field;
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailPattern.test(email.value)) {
                    field.parentElement.classList.add('error');
                    isValid = false;
                }
            }
            if (field.getAttribute('type') === 'checkbox') {
                const checkbox = field;
                if (checkbox.checked === false) {
                    field.parentElement.classList.add('error');
                    isValid = false;
                }
            }
        });
        return isValid;
    }
}
